module.exports = __webpack_public_path__ + "static/media/1007139.5b1f5701.jpg";